<template>
<div class="fixedPointAddressing">
  <box ref="box"></box>
  <el-row :gutter="10">
    <el-col :span="12">
      <el-card shadow="never" :style="style">
        <div slot="header" class="clearfix">
          <span>{{ $t('queryButton') }}</span>
        </div>
        <div class="detail" v-for="(item, index) in psnArr" :key="index">{{item}}</div>
        <el-form :model="searchForm" class="form" label-width="90px">
          <el-form-item :label="$t('panelNumber')">
            <el-input-number size="mini" v-model="searchForm.controllerNo" :min="0" :max="254"></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('loopNo')">
            <el-input-number size="mini" v-model="searchForm.loopNo" :min="0" :max="254"></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('componentNumber')">
            <el-input-number size="mini" v-model="searchForm.codeNo" :min="0" :max="254"></el-input-number>
          </el-form-item>
          <el-form-item>
            <el-button style="width: 90px" type="primary" @click="_getPositionAddress()" :loading="searching">{{$t('queryButton')}}</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
    <el-col :span="12">
      <el-card shadow="never" :style="style">
        <div slot="header" class="clearfix">
          <span>{{ $t('set') }}</span>
        </div>
        <el-form :model="setForm" label-width="90px" class="formSetting">
          <el-form-item :label="$t('psn1')">
            <el-input v-model="setForm.psn" :placeholder="$t('psnCode')" clearable></el-input>
          </el-form-item>
          <el-form-item :label="$t('panelNumber')">
            <el-input-number size="mini" v-model="setForm.controllerNo" :min="0" :max="254"></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('loopNo')">
            <el-input-number size="mini" v-model="setForm.loopNo" :min="0" :max="254"></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('componentNumber')">
            <el-input-number size="mini" v-model="setForm.codeNo" :min="0" :max="254"></el-input-number>
          </el-form-item>
          <el-form-item>
            <el-button style="width: 90px" type="primary" @click="_setPositionAddress" :loading="setting">{{$t('set')}}</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
  </el-row>
</div>
</template>

<script>
import Box from "@/components/Box";
import {getPositionAddress, setPositionAddress} from "@/api/install"
import Status from "components/Status";
export default {
  name: "fixedPointAddressing",
  mixins: [Status],
  components: {
    Box
  },
  data() {
    return {
      searchForm: {
        codeNo: '',
        loopNo: '',
        controllerNo: ''
      },
      setForm: {
        codeNo: '',
        loopNo: '',
        controllerNo: '',
        psn: ''
      },
      bottomHeight: null,
      style: null,
      psnArr: [],
      searching: false,
      setting: false
    }
  },
  mounted() {
    this.calcHeight()
  },
  computed: {
    controllInfo() {
      return this.$store.state.controlInfo
    }
  },
  methods: {
    calcHeight(){
      setTimeout(() => {
        this.bottomHeight = this.$refs.box.$el.clientHeight + 'px'
        this.style = `height: calc(100vh - 100px - ${this.bottomHeight})`
      }, 20)
    },
    handleChange(value) {
      console.log(value);
    },
    _getPositionAddress(){
      this.searching = true
      this.show()
      let searchParams = {
        codeNo: this.searchForm.codeNo,
        controllerPsn: this.controllInfo.controllerPsn,
        controllerNo: this.searchForm.controllerNo,
        loopNo: this.searchForm.loopNo
      }
      getPositionAddress(searchParams).then((res) => {
        this.psnArr = res.data.psnArr
        this.searching = false
        this.success(res.message ? res.message : '操作成功')
      }).catch(() => {
        this.searching = false
        this.failed()
      })
    },
    _setPositionAddress() {
      if (this.setForm.psn === '') {
        this.$message.warning('请指定psn')
        return
      }
      this.setting = true
      this.show()
      let searchParams = {
        codeNo: this.setForm.codeNo,
        controllerPsn: this.controllInfo.controllerPsn,
        controllerNo: this.setForm.controllerNo,
        loopNo: this.setForm.loopNo,
        psn: this.setForm.psn
      }
      setPositionAddress(searchParams).then((res) => {
        if (res.code === 1) {
          this.setting = false
          this.success(res.message ? res.message : '操作成功')
        }
      }).catch(() => {
        this.setting = false
        this.failed()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.fixedPointAddressing{
  .el-card {
    margin-bottom: 10px;

    .el-card__header {
      span {
        font-size: 16px;
        font-family: Microsoft YaHei, serif !important;
        color: #2F4E68;
        font-weight: bold;
      }

      .clearfix:before,
      .clearfix:after {
        display: table;
        content: "";
      }

      .clearfix:after {
        clear: both
      }
    }
    .detail{
      text-align: center;
      line-height: 30px;
      &:nth-child(3){
        padding-bottom: 10px;
      }
    }
    .form{
      text-align: center;
      .el-form-item{
        width: 220px;
        text-align: center;
        margin: auto;
        padding: 5px;
        &:nth-child(3){
          padding-bottom: 10px;
        }
        .el-form-item__content{
          width: 130px;
        }
      }
      .el-input-number.is-without-controls .el-input__inner {
        width: 100px;
        line-height: 30px;
        height: 28px;
      }

    }
    .formSetting{
      text-align: center;
      .el-form-item{
        width: 220px;
        text-align: center;
        margin: auto;
        padding: 5px;
        &:nth-child(1) {
          padding-bottom: 65px;
        }
        &:nth-child(4){
          padding-bottom: 10px;
        }
        .el-form-item__content{
          width: 130px;
        }
      }
      .el-input-number.is-without-controls .el-input__inner {
        width: 100px;
        line-height: 30px;
        height: 28px;
      }

    }
  }
}
</style>
